"use client";

import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { fadeUp, scaleIn, Section, img } from "./utils";

export function Testimonials() {
  return (
    <Section className="px-6 py-28 max-w-5xl mx-auto">
      <motion.div variants={fadeUp} className="text-center mb-12">
        <p className="text-sm font-medium text-coral-400 mb-3 uppercase tracking-wider">
          From real teams
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-content">
          Don&apos;t take our word for it.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div
          variants={scaleIn}
          custom={0}
          className="bg-surface/60 border border-surface-border rounded-2xl p-8"
        >
          <div className="flex gap-0.5 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={14}
                className="text-coral-400 fill-coral-400"
              />
            ))}
          </div>
          <Quote size={28} className="text-coral-500/20 mb-3" />
          <p className="text-base text-content/80 leading-relaxed">
            &ldquo;We were losing leads every weekend because nobody was
            following up fast enough. Tethra picked up 34 conversations in the
            first 48 hours — qualifying, scheduling viewings, and following up
            automatically. Two closed within the month — that&apos;s AED 180K
            we would have missed.&rdquo;
          </p>
          <div className="flex items-center gap-4 mt-6">
            <img
              src={img.officeTeam}
              alt="Khalid"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <p className="text-sm font-semibold text-content">
                Khalid Al-Rashid
              </p>
              <p className="text-xs text-content-muted">
                Managing Partner, Gulf Realty Co.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={scaleIn}
          custom={1}
          className="bg-surface/60 border border-surface-border rounded-2xl p-8"
        >
          <div className="flex gap-0.5 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={14}
                className="text-coral-400 fill-coral-400"
              />
            ))}
          </div>
          <Quote size={28} className="text-coral-500/20 mb-3" />
          <p className="text-base text-content/80 leading-relaxed">
            &ldquo;We used to have a 4-hour average response time on booking
            requests. Now it&apos;s under 3 minutes. Our fleet utilization went
            from 62% to 89% because we&apos;re not leaving money on the
            table anymore.&rdquo;
          </p>
          <div className="flex items-center gap-4 mt-6">
            <img
              src={img.testimonial2}
              alt="Ravi"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <p className="text-sm font-semibold text-content">
                Ravi Sharma
              </p>
              <p className="text-xs text-content-muted">
                Operations Director, DriveHub Fleet
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>
  );
}
